import React from "react";
import { useTranslation } from "react-i18next";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useNavigate, NavigateFunction } from "react-router-dom";

interface BackButtonProps {
  text?: string;
  navigateTo?: string;
  onClick?: () => void;
}

const BackButton: React.FC<
  BackButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>
> = ({ text, navigateTo, onClick, ...props }) => {
  const navigate: NavigateFunction = useNavigate();
  const { t } = useTranslation();

  const handleBacktoHome = () => {
    if (navigateTo) {
      navigate(navigateTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <button
      {...props}
      onClick={onClick || handleBacktoHome}
      type="button"
      className="text-brand-gray rounded-full px-3 py-2 flex items-center gap-1 border border-brand-gray hover:bg-gray-600 hover:text-white hover:border-gray-600 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent disabled:hover:text-brand-gray "
    >
      <MdKeyboardArrowLeft />
      <span>{text || t("Back")}</span>
    </button>
  );
};

export default BackButton;
